(ns frontend.view.modals.memo.view
  (:require
   [common.localization :as loc]
   [frontend.bootstrap.components :as rbs]
   [frontend.view.modals.memo.events :as events]
   [frontend.utils :as fu]
   [ui.components.modal.view :as modal]))

(defonce modal-key :download-memo-modal)

(defn body-text
  [status]
  (case status
    :processing (loc/tr :wait-for-processing-text)
    :failed (loc/tr :failed-to-process-file-text)
    :ok (loc/tr :success-file-is-ready-to-be-downloaded-text)
    (loc/tr :error-processing-file-text)))

(defn view
  [{:keys [shown? close-modal! props state class-name topmost?]}]
  (let [{:keys [oppo-id full? skip-blank-values?]} props
        on-close! (fn []
                    (close-modal!))
        process-status (when state (:processing-status @state))
        url (when state (:download-url @state))]
    (events/create-memo! state oppo-id full? skip-blank-values?)
    (fn [{:keys [shown? close-modal! props state class-name topmost?]}]
      (let [{:keys [oppo-id full? skip-blank-values?]} props
            on-close! (fn []
                        (close-modal!))
            process-status (when state (:processing-status @state))
            url (when state (:download-url @state))]
        [modal/view
         {:visible?      (and shown? topmost?)
          :hide!         close-modal!
          :backdrop      "static"
          :close-button? true}
         ""
         [:<>
          [:div
           {:class "text-center"}
           (case process-status
             :processing [:span.max-width-spinner [:i.fal.fa-spinner.fa-pulse.fa-3x.theme-color]]
             :ok [:a
                  {:href       url
                   :on-click   on-close!
                   :class-name "flex justify-center items-center gap-3 text-xl text-base-light-text-accent text-bold"
                   :target     "_blank"}
                  [:i.fal.fa-cloud-download " "]
                  (loc/tr :download-url)]
             [:img
              {:src        "/img/not-published-service.svg"
               :class-name "img-fluid max-width"}]
           )]
          [:p
           {:class "py-6 text-bold text-center"}
           (body-text process-status)]
          nil]]))))
